'use client';

import Link from 'next/link';
import {
  NavigationMenu,
  NavigationMenuLink,
  NavigationMenuList,
  navigationMenuTriggerStyle,
} from '@/components/ui/navigation-menu';
import { trackEvent } from '@/utils/analytics';
import { NavDropdown } from './nav-dropdown';
import type { DesktopNavigationProps } from './types';

export function DesktopNavigation({
  navigationLinks,
  destinations,
  services,
}: DesktopNavigationProps) {
  const handleNavLinkClick = (label: string) => {
    trackEvent({
      action: 'navigation_link_click',
      category: 'navigation',
      label: label,
      value: 1,
    });
  };

  return (
    <div className="hidden lg:flex justify-center gap-x-8 flex-1">
      <NavigationMenu>
        <NavigationMenuList>
          <NavigationMenuLink className={navigationMenuTriggerStyle()} asChild>
            <Link href="/" onClick={() => handleNavLinkClick('Home')}>
              Home
            </Link>
          </NavigationMenuLink>

          {/* Destinations Dropdown */}
          <NavDropdown
            items={destinations}
            title="Destinations"
            allItemsHref="/destinations"
            trackingCategory="destinations"
          />

          {/* Services Dropdown */}
          <NavDropdown
            items={services}
            title="Services"
            allItemsHref="/services"
            trackingCategory="services"
          />

          {/* Navigation Links */}
          {navigationLinks.map((link) => (
            <NavigationMenuLink
              key={link.href}
              className={navigationMenuTriggerStyle()}
              asChild
            >
              <Link href={link.href} onClick={() => handleNavLinkClick(link.label)}>
                {link.label}
              </Link>
            </NavigationMenuLink>
          ))}
        </NavigationMenuList>
      </NavigationMenu>
    </div>
  );
}
